module.exports = __webpack_public_path__ + "media/images/payments/square-dark-4bfe14e3a8332437bf0fd38caa47e54e.svg";